import React from 'react';
import PropTypes from 'prop-types';
import CardLayoutHeaderSkeleton from './CardLayoutHeaderSkeleton';

/** Declarative container for the Card toolbar area (breadcrumbs, fullscreen toggle, close button) */
export const CardLayoutToolbar = ({ children }) => children;
CardLayoutToolbar.displayName = 'CardLayoutToolbar';
CardLayoutToolbar.propTypes = {
  children: PropTypes.node
};

/** Declarative container for the Card header area (image, title, aliases, dates, tags).
 * @param isLoading - when true, renders skeleton instead of children
 * @param height - expanded wrapper height (default '236px'); consumed by CardLayout
 * @param collapsible - show the manual collapse toggle (default true); consumed by CardLayout
 * @param collapseOnScroll - collapse the header on scroll down / expand on scroll up; consumed by
 *   CardLayout, which then owns the content scroll region (children must not scroll themselves) */
export const CardLayoutHeader = ({ children, isLoading }) => (isLoading ? <CardLayoutHeaderSkeleton /> : children);
CardLayoutHeader.displayName = 'CardLayoutHeader';
CardLayoutHeader.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  height: PropTypes.string,
  collapsible: PropTypes.bool,
  collapseOnScroll: PropTypes.bool
};

/** Declarative container for the Card tabs bar */
export const CardLayoutTabs = ({ children }) => children;
CardLayoutTabs.displayName = 'CardLayoutTabs';
CardLayoutTabs.propTypes = {
  children: PropTypes.node
};

/** Declarative container for the Card tab content area */
export const CardLayoutContent = ({ children }) => children;
CardLayoutContent.displayName = 'CardLayoutContent';
CardLayoutContent.propTypes = {
  children: PropTypes.node
};
